import GoogleOauthService from '../../service/GoogleOauthService';
import { Consumer as C, createContext } from 'react';

export { default as GoogleOauthService } from '../../service/GoogleOauthService';
export const context = createContext<GoogleOauthService>({} as GoogleOauthService);

export const Provider = context.Provider;
export const Consumer = context.Consumer as C<GoogleOauthService>;
